import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from "@microsoft/signalr";
import { Invoice, IPushData, IServiceOptions, MessageType } from "@posx/core";
import { eventBus } from "./event.worker";
import { ServicesBuilder } from "@/utils/setup.utils";

export class DataWorker {
    private static instance: DataWorker;
    private static connection: HubConnection;
    private static options: IServiceOptions;
    private static url : string;
  
    private constructor() {}
  
    public static getInstance(): DataWorker {
      if (!DataWorker.instance) {
        DataWorker.instance = new DataWorker();
      }
      return DataWorker.instance;
    }
  
    public async createOrUpdateConnection(options: IServiceOptions): Promise<HubConnection | undefined> {
      DataWorker.options = options;
      if (options.merchant_uid) {
        try {
          const newUrl = `${options.base_url}xhub/?merchant-uid=${options.merchant_uid}&device-uid=${options.device_uid}&token=${options.token}`;
          if (DataWorker.connection && DataWorker.connection.state === HubConnectionState.Connected) {
            if(DataWorker.url === newUrl) return DataWorker.connection;
            await DataWorker.connection.stop();
            DataWorker.connection.baseUrl = newUrl;
          } else {
            DataWorker.url = options.base_url + `xhub/?merchant-uid=${options.merchant_uid}&device-uid=${options.device_uid}&token=${options.token}`;
            DataWorker.connection = new HubConnectionBuilder()
              .withUrl(
                DataWorker.url,
                { withCredentials: false }
              )
              .configureLogging(LogLevel.Information)
              .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) => {
                  return 3000;
                },
              })
              .build();
            // Match server ClientTimeoutInterval=45s (3x keepAlive=15s)
            DataWorker.connection.serverTimeoutInMilliseconds = 45000;
            DataWorker.connection.keepAliveIntervalInMilliseconds = 15000;
          }

          DataWorker.connection.on('receive_invoice', async (invoice: Invoice) => {
            console.log('Incoming invoice:', JSON.stringify(invoice));
          });
  
          DataWorker.connection.on('sync', async (syncData: IPushData) => {
            try {
              console.log('Incoming message:', JSON.stringify(syncData));
              if (syncData) {
                if (syncData.type === MessageType.Event) {
                  if (syncData.data === 'sync ends') {
                    eventBus.emit('sync ends', syncData.data);
                  } else if (syncData.data === 'sync sensitive data ends') {
                    eventBus.emit('sync sensitive data ends', syncData.data);
                  } else if (syncData.data === 'node detected') {
                    console.log('Node detected');
                    return 1;
                  }
                } else if (syncData.type === MessageType.Data) {
                  const service = await ServicesBuilder.getInstance().getServiceByName(syncData.model);
                  if (!syncData.has_many) {
                    await service.saveOne(JSON.parse(syncData.data));
                  } else {
                    await service.saveMany(JSON.parse(syncData.data));
                  }
                }
              }
              return 1;
            } catch (error) {
              console.error('Error saving data:', error);
              return 0;
            }
          });

          DataWorker.connection.on('ods_data', async (invoice: Invoice) => {
            try {
              eventBus.emit('receive invoice', invoice);
              return 1;
            } catch (error) {
              console.error('Error saving invoice:', error);
              return 0;
            }
          })
  
          await DataWorker.connection.start();
          return DataWorker.connection;
        } catch (error) {
          console.error('Error while establishing or updating connection: ', error);
        }
      }
    }
  
    public async closeConnection(): Promise<void> {
      if (DataWorker.connection) {
        await DataWorker.connection.stop();
      }
    }
  
    public getConnection(): HubConnection{
      return DataWorker.connection;
    }
  }

